import {
    computed,
} from 'vue';
import {
    useSnackbar,
} from '../stores/snackbars-store';

/**
 * Bridge functions to decouple snackbar usage from implementation details
 * Currently the snackbar uses a pinia store as driver.
 */

/**
 *  * Function takes an object as a parameter
 *  * @param {Object} props An object containing the following optional keys:
 *  * @param {String} [props.text] A text string to be displayed
 *  * @param {String} [props.dataQa] A string containing the data-qa attribute
 *  * @param {String} [props.icon] A string containing the name of the icon to be displayed
 */
export function showSnackbar(props) {
    const renderProps = {
        text: 'Kein Text übergeben',
        dataQa: undefined,
        icon: 'check',
        ...props,
    };
    const snackbar = useSnackbar();
    return snackbar.showSnackbar(renderProps);
}

export const shouldShowSnackbar = computed(() => {
    const snackbar = useSnackbar();
    return snackbar.snackbarData !== null;
});

export const snackbarData = computed(() => {
    const snackbar = useSnackbar();
    return snackbar.snackbarData;
});
